module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/plus-1213f3507acfa475941377da1e775fd8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/plus.svg
// module id = rvs1
// module chunks = 24